import styled from 'styled-components';

export const TableImg = styled.img<{ height?: number }>`
  border-radius: 3px;
  height: ${({ height }) => (height != null && height > 0 ? height : 30)}px;
  margin: 0 5px 5px 0;
`;
